class SecurityIssuesData {
    /**
     * Constructor.
     */
    constructor(public total: number, public timedCount: number) {}
}

export default SecurityIssuesData;
